import type { WorkspaceContextRequirement } from "@/utils/workspace-context-gate";

type WorkspaceScopedQuery = Record<string, unknown> & {
  workspace__id?: string | number;
};

export function scopeServiceQuery<Query extends WorkspaceScopedQuery>(
  query: Query,
  workspaceId: string | number | undefined,
  workspaceContextRequirement: WorkspaceContextRequirement
): Query {
  if (workspaceContextRequirement === "none") return query;
  return {
    ...query,
    workspace__id: query.workspace__id ?? workspaceId
  };
}
